import { render, staticRenderFns } from "./HeadingArrowed.vue?vue&type=template&id=70b6e34d&lang=pug&"
import script from "./HeadingArrowed.vue?vue&type=script&lang=js&"
export * from "./HeadingArrowed.vue?vue&type=script&lang=js&"
import style0 from "./HeadingArrowed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports